export default __webpack_public_path__ + "static/media/five_stars.929d083f.svg";